import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createApiClient } from '../../api/client';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: '#ccc',
  borderRadius: '8px',
  padding: '12px',
  marginBottom: '12px',
  fontFamily: 'inherit',
  fontSize: '14px',
};

const PRIORITY_TO_CATEGORY = {
  Top: 'Level 1',
  High: 'Level 2',
  Medium: 'Level 3',
  Low: 'Level 4',
};

const PRIORITIES = ['Top', 'High', 'Medium', 'Low'];

const NewTask = ({ API_URL }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR, setFullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;

  const [description, setDescription] = useState('');
  const [note, setNote] = useState('');
  const [urgency, setUrgency] = useState('');
  const [priority, setPriority] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isDisabled = loading || !description.trim() || !priority;

  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      const response = await api.post('/fir/task', {
        firId: fir.id,
        description: description.trim(),
        note: note.trim(),
        urgency: urgency.trim(),
        category: PRIORITY_TO_CATEGORY[priority],
      });
      setFullFIR(response.data);
      navigate('/m/fir/tasks', { state: { fir: response.data } });
    } catch {
      setErrorMessage('Failed to add task. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Add Task</h2>

      <textarea
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={3}
        style={inputStyle}
      />

      <textarea
        placeholder="Note (where / from whom)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        rows={2}
        style={inputStyle}
      />

      <textarea
        placeholder="Relevance"
        value={urgency}
        onChange={(e) => setUrgency(e.target.value)}
        rows={2}
        style={inputStyle}
      />

      <div style={{ marginBottom: '12px' }}>
        <div style={{ fontSize: '16px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>Priority</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          {PRIORITIES.map((p) => (
            <label key={p} style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', boxSizing: 'border-box', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={priority === p}
                onChange={() => setPriority(priority === p ? '' : p)}
                style={{ width: '16px', height: '16px', margin: 0, flexShrink: 0 }}
              />
              {p}
            </label>
          ))}
        </div>
      </div>

      <button onClick={handleSubmit} disabled={isDisabled} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Submit'}
      </button>

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewTask;
